<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="overflow-auto">
          <ts-loading-banner :loading="student_search">
            <div id="student-list">
              <div v-if="selectedStudent" class="selected-student-summary">
                <div class="selected-student-header">
                  <div>
                    <strong>{{ selectedStudent.student_profile.full_name_en }}</strong>
                    <span class="text-muted ml-2">{{ selectedStudent.student_profile.card_number }}</span>
                  </div>
                  <button
                    type="button"
                    class="selected-student-clear"
                    :title="$t('clear')"
                    @click="clearStudent"
                  >
                    <i class="fa fa-times"></i>
                  </button>
                </div>
                <div class="selected-student-meta">
                  <span>{{ selectedStudent.academic_class.academic_term.term_name }}</span>
                  <span v-if="selectedStudent.academic_class.grade">
                    {{ selectedStudent.academic_class.grade.grade_name_foreign }}
                  </span>
                  <span>{{ selectedStudent.study_time }}</span>
                </div>
              </div>
              <table class="table table-hover ui-table ts-table">
                <thead>
                  <tr>
                    <th>{{ $t('preInvoice.cardNumber') }}</th>
                    <th>{{ $t('preInvoice.studentName') }}</th>
                    <th style="width:7%">{{ $t('preInvoice.sex') }}</th>
                    <th>{{ $t('preInvoice.academicTermName') }}</th>
                    <th>{{ $t('preInvoice.gradeName') }}</th>
                    <th>{{ $t('preInvoice.status') }}</th>
                  </tr>
                  <tr>
                    <th colspan="6">
                      <input
                        v-model.trim="searchValue"
                        type="text"
                        class="form-control"
                        :class="{ loading: student_search }"
                        :placeholder="$t('preInvoice.searchStudent')"
                      />
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(student, index) in studentResource"
                    :key="studentRowKey(student, index)"
                    :class="{ 'selected-class': index == selectedIndex }"
                    tabindex="0"
                    @click="selectStudent(student, index)"
                    @keyup.enter="selectStudent(student, index)"
                    @keyup.space.prevent="selectStudent(student, index)"
                  >
                    <td class="ts-whitespace-no-wrap">
                      {{ student.student_profile.card_number }}
                    </td>
                    <td class="ts-whitespace-no-wrap">
                      {{ student.student_profile.full_name_en }}
                    </td>
                    <td class="ts-whitespace-no-wrap">
                      {{ student.student_profile.gender }}
                    </td>
                    <td class="ts-whitespace-no-wrap">
                      {{ student.academic_class.academic_term.term_name }}
                    </td>
                    <td class="ts-whitespace-no-wrap">
                      <div>
                        {{
                          student.academic_class.grade
                            ? student.academic_class.grade.grade_name_foreign
                            : null
                        }}
                      </div>
                      <div class="student-row-subtext">{{ student.study_time }}</div>
                    </td>
                    <td class="ts-whitespace-no-wrap">
                      <span
                        class="badge badge-primary"
                        v-if="student.academic_class.ac_status_id == 1"
                        >{{ $t('preInvoice.current') }}</span
                      >
                      <span v-else class="badge badge-info">{{
                        $t('next')
                      }}</span>
                    </td>
                  </tr>
                  <tr v-if="!hasSearched && !searchValue && studentResource.length == 0">
                    <td colspan="6" class="student-empty text-center">
                      <div class="student-empty-icon">
                        <i class="fa fa-search"></i>
                      </div>
                      <div class="student-empty-title">
                        {{ $t('preInvoice.studentSearchInitialTitle') }}
                      </div>
                      <div class="student-empty-hint">
                        {{ $t('preInvoice.studentSearchInitialHint') }}
                      </div>
                    </td>
                  </tr>
                  <tr v-if="hasSearched && searchValue && !student_search && studentResource.length == 0">
                    <td colspan="6" class="student-empty text-center">
                      <div class="student-empty-icon">
                        <i class="fa fa-search-minus"></i>
                      </div>
                      <div class="student-empty-title">
                        {{ $t('preInvoice.studentSearchEmptyTitle') }}
                      </div>
                      <div class="student-empty-hint">
                        {{ $t('preInvoice.studentSearchEmptyHint') }}
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div class="validate" v-if="errors.has('student_id')">
                {{ errors.first('student_id') }}
              </div>
            </div>
          </ts-loading-banner>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapActions } from 'vuex'
import { Errors } from 'form-backend-validation'

export default {
  name: 'preInvoiceStudentList',
  props: ['value', 'validate'],
  data() {
    return {
      model: {},
      student_search: false,
      searchValue: '',
      studentResource: [],
      errors: new Errors(),
      selectedIndex: null,
      selectedStudent: null,
      hasSearched: false
    }
  },
  created() {
    this.model = this.value
  },
  methods: {
    ...mapActions('preInvoice', ['getStudent']),
    studentRowKey(student, index) {
      return student.st_class_id || index
    },
    selectStudent(student, index) {
      this.selectedIndex = index
      this.selectedStudent = student
      this.model.term_stop = ''
      this.model.total_amount = ''
      this.model.student_id = student.student_id
      this.model.acp_id = student.academic_class.acp_id
      this.model.acps_id = student.academic_class.acps_id
      this.model.study_time = student.study_time
      if (student.academic_class.room) {
        this.$store.commit(
          'preInvoice/SET_ROOM_TYPE_ID',
          student.academic_class.room.room_type_id
        )
      }
      this.$emit('student-info', student)
    },
    searchStudent(params) {
      this.student_search = true
      this.hasSearched = true
      this.studentResource = []
      this.selectedIndex = null
      this.getStudent(params)
        .then(response => {
          this.studentResource = _.uniqWith(response.data, _.isEqual)
        })
        .finally(() => {
          this.student_search = false
        })
    },
    clearStudent() {
      this.searchValue = ''
      this.studentResource = []
      this.hasSearched = false
      this.selectedStudent = null
      this.selectedIndex = null
      this.model.student_id = ''
      this.model.ac_year_id = ''
      this.model.acp_id = ''
      this.model.ac_status_id = ''
      this.model.term_stop = ''
      this.model.acps_id = ''
      this.model.ac_term_id = null
      this.model.grade_id = null
      this.model.study_time = ''
      this.model.total_amount = ''
      this.model.remark = ''
      this.model.vehicle_id = ''
      this.model.inv_detail_list = []
      this.$store.commit('preInvoice/SET_ROOM_TYPE_ID', null)
      this.$emit('student-info', null)
    }
  },
  watch: {
    searchValue: debounce(function(value) {
      if (value) {
        this.searchStudent({
          search: value,
          filter: {
            ac_status_id: '1'
          },
          page: -1
        })
      } else {
        this.studentResource = []
        this.selectedIndex = null
        this.hasSearched = false
      }
    }, 500),
    validate: function(error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>

<style lang="css" scoped>
#student-list {
  height: 279px;
  overflow: auto;
}
.selected-student-summary {
  padding: 8px 10px;
  margin-bottom: 8px;
  border: 1px solid #d9e8f8;
  border-radius: 4px;
  background: #f6fbff;
}
.selected-student-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}
.selected-student-clear {
  width: 24px;
  height: 24px;
  padding: 0;
  border: 0;
  border-radius: 4px;
  background: transparent;
  color: #6b7280;
  cursor: pointer;
}
.selected-student-clear:hover,
.selected-student-clear:focus {
  background: #e5eef8;
  color: #1f2937;
  outline: none;
}
.selected-student-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 4px;
  color: #5f6b7a;
  font-size: 12px;
}
table > thead > tr > th {
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  z-index: 999;
  padding: 7px;
  border-bottom: none !important;
}
table > tbody > tr {
  cursor: pointer;
}
table > tbody > tr > td {
  padding-top: 6px !important;
  padding-bottom: 6px !important;
  vertical-align: middle;
}
table > tbody > tr:focus {
  outline: 2px solid #8ec5ff;
  outline-offset: -2px;
}
.selected-class > td {
  border-top: 1px solid #b8dcff;
  border-bottom: 1px solid #b8dcff;
  background: #eaf4ff;
  color: #17324d;
  font-weight: 600;
}
.student-row-subtext {
  margin-top: 2px;
  color: #6b7280;
  font-size: 12px;
}
.selected-class .student-row-subtext {
  color: #486581;
}
.student-empty {
  padding: 24px 8px !important;
}
.student-empty-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  margin-bottom: 8px;
  border-radius: 50%;
  background: #eef6ff;
  color: #1d68b3;
}
.student-empty-title {
  color: #374151;
  font-weight: 600;
}
.student-empty-hint {
  margin-top: 4px;
  color: #6b7280;
  font-size: 12px;
}
.loading {
  background-color: #ffffff;
  background-image: url('http://loadinggif.com/images/image-selection/3.gif');
  background-size: 18px 18px;
  background-position-x: 99%;
  background-position-y: 50%;
  background-repeat: no-repeat;
}
</style>
